import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ajaxStations from "../../util/remote/ajaxStations";
import toast from "react-hot-toast";
import ajaxStationOwners from "../../util/remote/ajaxStationOwners";
const PageHeader = ({ title, previousPageTitle, actions = [] }) => {
  const navigate = useNavigate();
  const company_id = Number(localStorage.getItem("FuelFy@company_id"));
  const station_id = Number(localStorage.getItem("FuelFy@station_id"));
  const handleExitStation = () => {
    localStorage.removeItem("FuelFy@station_id");
    navigate("/fuel_stations/view_fuel_stations");
    // window.location.reload(); //
  };
  const isCompanyUser = localStorage.getItem("FuelFy@is_company_user");
  const activeStationId = localStorage.getItem("FuelFy@station_id");
  //fetch the station_name if the station_id is set
  const [Station_name, setStation_name] = useState([]);
  const fetchGroups = async () => {
    var data = { station_id: activeStationId };
    const response = await ajaxStations.get_station_name(data);
    if (response.status === "OK") {
      setStation_name(response.details);
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    fetchGroups();
  }, [activeStationId]);
  const [company_name, setcompany_name] = useState([]);
  const fetch_company = async () => {
    var data = { company_id: company_id };
    const response = await ajaxStationOwners.get_station_company_name(data);
    if (response.status === "OK") {
      setcompany_name(response.details);
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    fetch_company();
  }, [isCompanyUser]);
  return (
    <div className="page-header d-flex justify-content-between align-items-center">
      <div>
        <h2 className="main-content-title tx-24 mg-b-5">
          {station_id
            ? Station_name || title
            : company_id
            ? company_name || title
            : title}
        </h2>
        {previousPageTitle && (
          <ol className="breadcrumb">
            <li className="breadcrumb-item">{previousPageTitle}</li>
            <li className="breadcrumb-item active">{title}</li>
          </ol>
        )}
      </div>
      <div className="btn btn-list d-flex gap-2">
        {/* SHOW EXIT BUTTON ONLY IF both IDs exist */}
        {company_id && station_id ? (
          <button
            className="btn ripple btn-danger btn-sm"
            onClick={handleExitStation}
          >
            <i className="fa-solid fa-person-walking-arrow-loop-left" /> &nbsp;
            Exit Station Profile
          </button>
        ) : null}
        {/* Render other dynamic buttons */}
        {actions.map((btn, index) => (
          <button
            key={index}
            className={btn.className || "btn btn-secondary btn-sm"}
            onClick={btn.onClick}
          >
            {btn.icon && <i className={`${btn.icon} mr-1`} />}
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
};
export default PageHeader;
